import { createReducer, on } from "@ngrx/store";
import { ExternalInitialAssessmentState, initialExternalInitialAssessmentState } from "./external-initial-assessment.state";
import { AddExternalInitialAssessment, AddExternalInitialAssessmentError, AddExternalInitialAssessmentSuccess, ResetExternalInitialAssessmentProperties } from "./external-initial-assessment.actions";

export const ExportInitialAssessmentReducers = createReducer(
  initialExternalInitialAssessmentState,
  on(AddExternalInitialAssessment, (state): ExternalInitialAssessmentState => {
    return {
      ...state,
      createExtInitAssessmentLoader: true,
      createExtInitAssessmentError: null,
    }
  }),
  on(AddExternalInitialAssessmentSuccess, (state, action): ExternalInitialAssessmentState => {
    return {
      ...state,
      externalInitAssessmentResult: action.result,
      createExtInitAssessmentLoader: false,
      createExtInitAssessmentError: null,
    }
  }),
  on(AddExternalInitialAssessmentError, (state, action): ExternalInitialAssessmentState => {
    return {
      ...state,
      createExtInitAssessmentLoader: false,
      createExtInitAssessmentError: action.error,
    }
  }),
  on(ResetExternalInitialAssessmentProperties, (state): ExternalInitialAssessmentState => {
    return {
      ...state,
      externalInitAssessmentResult: null,
      createExtInitAssessmentError: null,
    }
  }),
);